import { createFileRoute } from '@tanstack/react-router';
import { ChecklistIndex } from '@/pages/checklist/ChecklistIndex';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/checklist')({
	beforeLoad: ({ context }) => requireAnyPermission({ context, anyOf: ['checklists.read'], redirectTo: '/dashboard' }),
	component: ChecklistIndex,
});
